/**
 * this function removes any query parameters that may exist on a link
 * @param {String} path - the path to remove query params from
 * @return {String} - the provided link without query params
 */
export default function stripQueryParams(path) {
  return path.replace(/\?.*/, '');
}